<ng-container>
  <offer-card *ngIf="offerKind === OfferKind.SupplierOffer" [isEditable]="isEditable" (editing)="editing = $event" (onFormChange)="onFormChange($event)"></offer-card>
  <receiving-offer-card *ngIf="offerKind === OfferKind.ReceivingOffer" [isEditable]="isEditable"></receiving-offer-card>
  <request-offer-card *ngIf="offerKind === OfferKind.OfferRequest" [isEditable]="isEditable"></request-offer-card>
  <offer-files-card #files *ngIf="offerId" [isEditable]="isEditable && !appState.isVisitor()" [offerKind]="offerKind" [offerType]="offerType" [retailerId]="retailerId"></offer-files-card>
  <ng-container *ngIf="offerId"> 
    <ng-container *ngIf="offerKind !== OfferKind.OfferRequest">
      <offer-comments-card [isEditable]="isEditable"></offer-comments-card>
    </ng-container>
    <offer-history-card></offer-history-card>
  </ng-container>
</ng-container>
